var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.4C6.05733 1.4 5.17067 1.624 4.34 2.072C3.53733 2.50133 2.87933 3.094 2.366 3.85H4.2V5.25H0V1.05H1.4V2.8C2.05333 1.932 2.86067 1.25067 3.822 0.756001C4.81133 0.252001 5.87067 0 7 0C7.952 0 8.862 0.181999 9.73 0.546C10.5607 0.900666 11.3003 1.40233 11.949 2.051C12.5977 2.69967 13.0993 3.43933 13.454 4.27C13.818 5.138 14 6.048 14 7H12.6C12.6 5.98267 12.3433 5.04 11.83 4.172C11.3353 3.332 10.668 2.66467 9.828 2.17C8.96 1.65667 8.01733 1.4 7 1.4ZM1.4 7C1.4 8.01733 1.65667 8.96 2.17 9.828C2.66467 10.668 3.332 11.3353 4.172 11.83C5.04 12.3433 5.98267 12.6 7 12.6C7.94267 12.6 8.82933 12.376 9.66 11.928C10.4627 11.4987 11.1207 10.906 11.634 10.15H9.8V8.75H14V12.95H12.6V11.2C11.9467 12.068 11.1393 12.7493 10.178 13.244C9.18867 13.748 8.12933 14 7 14C6.048 14 5.138 13.818 4.27 13.454C3.43933 13.0993 2.69967 12.5977 2.051 11.949C1.40233 11.3003 0.900667 10.5607 0.546 9.73C0.182 8.862 0 7.952 0 7H1.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.3a975fed2b6c745514c75ebbcb20e5f7.svg";
export { ForwardRef as ReactComponent };